var lib_core = require("lib-core");
var lib_geometry = require('lib-geometry');
var IpcDataModel = require("./index.js");
var GenericSmdPadGeneratorData = require("../genericSmdPadGeneratorData.js");
var GenericPthPadGeneratorData = require("../genericPthPadGeneratorData.js");
var GenericSmdQuadPadGeneratorData = require("../genericSmdQuadPadGeneratorData.js");
var RectangleData = require("../../svg/rectangleData.js");
var EllipseData = require("../../svg/ellipseData.js");
var SmdPadstackData = require("../../padstack/smdPadstackData.js");
var PthPadstackData = require("../../padstack/pthPadstackData.js");
var HoleData = require("../holeData.js");
var PadData = require("../padData.js");
var FootprintGeneratorDefaultParams = require("./footprintGeneratorDefaultParams.js");

var FootprintGeneratorAddHelper = {};

FootprintGeneratorAddHelper.updatePadNames = function(data, rootData) {
    var padNames = rootData && rootData.padNames;
    var name = 1;

    function updateNameList() {
        if(padNames) name = padNames.getProposal('', name);
        data.nameList.push(name);
        name++;
    }

    //generic generators
    if(data instanceof GenericSmdPadGeneratorData || data instanceof GenericPthPadGeneratorData){
        for (var i = 0; i < (data.nCol() * data.nRow()); i++) {
            updateNameList();
        }
    } else if(data instanceof GenericSmdQuadPadGeneratorData) {
        for (var i = 0, totalPadCount = data.nCol() + data.nRow(); i < totalPadCount; i++) {
            updateNameList();
        }
    } else { //IPC generators
        var horizontalPadCount = data.horizontalPadCount();

        if(data instanceof IpcDataModel.QuadRowPackageData) { //quad packages
            var verticalPadCount = 2 * data.verticalPadCount(); //pad count for quad packages are defined per side in data
            horizontalPadCount = 2 * horizontalPadCount;

            for (var i = 0, totalPadCount = horizontalPadCount + verticalPadCount; i < totalPadCount; i++) {
                updateNameList();
            }
        } else if(data instanceof IpcDataModel.BgaData || data instanceof IpcDataModel.HeaderData) {
            var verticalPadCount = data.verticalPadCount();

            for (var i = 0, totalPadCount = horizontalPadCount * verticalPadCount; i < totalPadCount; i++) {
                updateNameList();
            }
        } else { //dual packages or standoffs
            if(!(data instanceof IpcDataModel.Dfn3Data) &&
            !(data instanceof IpcDataModel.Sot23Data) &&
            !(data instanceof IpcDataModel.Sot223Data) &&
            !(data instanceof IpcDataModel.ToDpakData) &&
            !(data instanceof IpcDataModel.SotflData)) {
                if (horizontalPadCount > 1) {
                    if (horizontalPadCount % 2 !== 0) ++horizontalPadCount;   
                } else {// for standoff pad count is one (optional mounting hole pad)
                    if (data instanceof IpcDataModel.FemaleStandoffSpacerData || data instanceof IpcDataModel.MaleFemaleStandoffSpacerData) {
                        // vias are just like regular pads so increase the count to generate pad names for vias
                        if (data.withVia()) {
                            horizontalPadCount += data.viaCount();
                        }
                    }
                }
            }

            for (var i = 0; i < horizontalPadCount; i++) {
                updateNameList();
            }
        }
    }

    //update thermal pad name if it exists
    if(data.hasThermalPad && data.hasThermalPad()) {
        updateNameList();
    }
};

//get generators with default params by type
//do not assign default values to footprint related params when 3d model is only being generated from IPC data in non wizard mode and footprint is not generated from IPC data
FootprintGeneratorAddHelper.getDefaultData = function(type, startCoord, rootData, only3dModel) {
    var data;

    switch(type) {
        case 'GenericSmdPadGeneratorData':
            var shape = new RectangleData(new lib_geometry.Coord(0,0), 0, 2200, 600, true, 0);
            var padstack = new SmdPadstackData(shape, true, false, 101.6, true, false, 0, true);
            var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__smdPadReplicatorMotif__", padstack, true);
            data = new GenericSmdPadGeneratorData(startCoord, 0, 2, 8, 5200, 1270, motif);
        break;

        case 'GenericPthPadGeneratorData':
            var shape = new RectangleData(new lib_geometry.Coord(0,0), 0, 3000, 1250, true, 0, undefined, 625, 625);
            var drill_shape = new EllipseData(new lib_geometry.Coord(0,0), 0, 800, 800, true, 0);
            var hole = new HoleData(new lib_geometry.Coord(0,0), 0, drill_shape);
            var padstack = new PthPadstackData(shape, shape.clone(), hole, true, false, 101.6);
            var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__pthPadReplicatorMotif__", padstack, true);
            data = new GenericPthPadGeneratorData(startCoord, 0, 2, 8, 5000, 2000, motif);
        break;

        case 'GenericSmdQuadPadGeneratorData':
            var shape = new RectangleData(new lib_geometry.Coord(0,0), 0, 2200, 600, true, 0);
            var padstack = new SmdPadstackData(shape, true, false, 101.6, true, false, 0, true);
            var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__smdPadReplicatorMotif__", padstack, true);
            data = new GenericSmdQuadPadGeneratorData(startCoord, 0, 16, 16, 13000, 13000, 1270, motif);
        break;

        case 'SoicSopData':
            data = new IpcDataModel.SoicSopData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.soic, only3dModel);

            data.customPadLength(FootprintGeneratorDefaultParams.soic.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.soic.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.soic.customPadSpan1);
        break;

        /*case 'CfpData':
            var data =  new IpcDataModel.CfpData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.cfp, only3dModel);
        break;*/

        case 'Sot23Data':
            var data =  new IpcDataModel.Sot23Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.sot23, only3dModel);

            data.customPadLength(FootprintGeneratorDefaultParams.sot23.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.sot23.customPadWidth);
            data.customPadPitch(FootprintGeneratorDefaultParams.sot23.customPadPitch);
        break;

        case 'SotflData':
            var data =  new IpcDataModel.SotflData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.sotfl, only3dModel);

            data.customPadLength(FootprintGeneratorDefaultParams.sotfl.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.sotfl.customPadWidth);
            data.customPadPitch(FootprintGeneratorDefaultParams.sotfl.customPadPitch);
        break;

        case 'Sot223Data':
            var data =  new IpcDataModel.Sot223Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.sot223, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.sot223.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.sot223.oddPadHeightMin);
            data.customPadLength(FootprintGeneratorDefaultParams.sot223.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.sot223.customPadWidth);
            data.customPadPitch(FootprintGeneratorDefaultParams.sot223.customPadPitch);
            data.customOddPadLength(FootprintGeneratorDefaultParams.sot223.customOddPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.sot223.customOddPadWidth);
        break;

        case 'ToDpakData':
            var data =  new IpcDataModel.ToDpakData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.toDpak, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.toDpak.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.toDpak.oddPadHeightMin);
            data.oddPadWidthMax(FootprintGeneratorDefaultParams.toDpak.oddPadWidthMax);
            data.oddPadWidthMin(FootprintGeneratorDefaultParams.toDpak.oddPadWidthMin);
            data.extendedEdgeWidth(FootprintGeneratorDefaultParams.toDpak.extendedEdgeWidth);

            data.customPadLength(FootprintGeneratorDefaultParams.toDpak.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.toDpak.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.toDpak.customPadSpan1);
            data.customOddPadLength(FootprintGeneratorDefaultParams.toDpak.customOddPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.toDpak.customOddPadWidth);
        break;

        case 'Sot143Data':
            var data =  new IpcDataModel.Sot143Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.sot143, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.sot143.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.sot143.oddPadHeightMin);
            data.customPadLength(FootprintGeneratorDefaultParams.sot143.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.sot143.customPadWidth);
            data.customOddPadLength(FootprintGeneratorDefaultParams.sot143.customOddPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.sot143.customOddPadWidth);
            data.customPadPitch(FootprintGeneratorDefaultParams.sot143.customPadPitch);
            data.pinPitch1(FootprintGeneratorDefaultParams.sot143.pinPitch1);
        break;

        case 'ChipData':
            var data =  new IpcDataModel.ChipData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.chip, only3dModel);

            data.oddPadWidthMax(FootprintGeneratorDefaultParams.chip.oddPadWidthMax);
            data.oddPadWidthMin(FootprintGeneratorDefaultParams.chip.oddPadWidthMin);
            data.componentFamily(FootprintGeneratorDefaultParams.chip.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.chip.customPadLength);
            data.customOddPadLength(FootprintGeneratorDefaultParams.chip.customOddPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.chip.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.chip.customPadToPadGap);
        break;

        case 'SodData':
            var data =  new IpcDataModel.SodData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.sod, only3dModel);

            data.customPadLength(FootprintGeneratorDefaultParams.sod.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.sod.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.sod.customPadToPadGap);
        break;

        case 'MoldedBodyData':
            var data =  new IpcDataModel.MoldedBodyData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.moldedBody, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.moldedBody.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.moldedBody.oddPadHeightMin);
            data.oddPadWidthMax(FootprintGeneratorDefaultParams.moldedBody.oddPadWidthMax);
            data.oddPadWidthMin(FootprintGeneratorDefaultParams.moldedBody.oddPadWidthMin);
            data.componentFamily(FootprintGeneratorDefaultParams.moldedBody.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.moldedBody.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.moldedBody.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.moldedBody.customPadToPadGap);
            data.customOddPadLength(FootprintGeneratorDefaultParams.moldedBody.customOddPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.moldedBody.customOddPadWidth);
        break;

        case 'SodflData':
            var data =  new IpcDataModel.SodflData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.sodfl, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.sodfl.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.sodfl.oddPadHeightMin);
            data.oddPadWidthMax(FootprintGeneratorDefaultParams.sodfl.oddPadWidthMax);
            data.oddPadWidthMin(FootprintGeneratorDefaultParams.sodfl.oddPadWidthMin);

            data.customPadLength(FootprintGeneratorDefaultParams.sodfl.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.sodfl.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.sodfl.customPadToPadGap);
            data.customOddPadLength(FootprintGeneratorDefaultParams.sodfl.customOddPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.sodfl.customOddPadWidth);
        break;

        case 'Dfn2Data':
            var data =  new IpcDataModel.Dfn2Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.dfn2, only3dModel);

            data.horizontalPinPitch(FootprintGeneratorDefaultParams.dfn2.horizontalPinPitch);
            data.horizontalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.dfn2.horizontalLeadToLeadSpanMax);
            data.horizontalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.dfn2.horizontalLeadToLeadSpanMin);
            data.componentFamily(FootprintGeneratorDefaultParams.dfn2.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.dfn2.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.dfn2.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.dfn2.customPadToPadGap);
        break;

        case 'Dfn3Data':
            var data =  new IpcDataModel.Dfn3Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.dfn3, only3dModel);

            data.horizontalPinPitch(FootprintGeneratorDefaultParams.dfn3.horizontalPinPitch);
            data.oddPadHeightMax(FootprintGeneratorDefaultParams.dfn3.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.dfn3.oddPadHeightMin);
            data.oddPadWidthMax(FootprintGeneratorDefaultParams.dfn3.oddPadWidthMax);
            data.oddPadWidthMin(FootprintGeneratorDefaultParams.dfn3.oddPadWidthMin);
            data.horizontalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.dfn3.horizontalLeadToLeadSpanMax);
            data.horizontalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.dfn3.horizontalLeadToLeadSpanMin);
            data.componentFamily(FootprintGeneratorDefaultParams.dfn3.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.dfn3.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.dfn3.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.dfn3.customPadToPadGap);
            data.customOddPadLength(FootprintGeneratorDefaultParams.dfn3.customOddPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.dfn3.customOddPadWidth);
        break;

        case 'Dfn4Data':
            var data =  new IpcDataModel.Dfn4Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.dfn4, only3dModel);

            data.horizontalPinPitch(FootprintGeneratorDefaultParams.dfn4.horizontalPinPitch);
            data.horizontalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.dfn4.horizontalLeadToLeadSpanMax);
            data.horizontalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.dfn4.horizontalLeadToLeadSpanMin);
            data.componentFamily(FootprintGeneratorDefaultParams.dfn4.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.dfn4.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.dfn4.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.dfn4.customPadToPadGap);
        break;

        case 'AluminumElectrolyticData':
            var data =  new IpcDataModel.AluminumElectrolyticData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.ecap, only3dModel);

            data.terminalGapMax(FootprintGeneratorDefaultParams.ecap.terminalGapMax);
            data.terminalGapMin(FootprintGeneratorDefaultParams.ecap.terminalGapMin);
            data.customPadLength(FootprintGeneratorDefaultParams.ecap.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.ecap.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.ecap.customPadToPadGap);
        break;

        case 'CrystalData':
            var data =  new IpcDataModel.CrystalData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.crystal, only3dModel);

            data.terminalGapMax(FootprintGeneratorDefaultParams.crystal.terminalGapMax);
            data.terminalGapMin(FootprintGeneratorDefaultParams.crystal.terminalGapMin);
            data.customPadLength(FootprintGeneratorDefaultParams.crystal.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.crystal.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.crystal.customPadToPadGap);
            data.customPadPitch(FootprintGeneratorDefaultParams.crystal.customPadPitch);
        break;

        case 'MelfData':
            var data =  new IpcDataModel.MelfData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.melf, only3dModel);

            data.componentFamily(FootprintGeneratorDefaultParams.melf.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.melf.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.melf.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.melf.customPadToPadGap);
        break;

        case 'ChipArrayTwoSideFlatConcaveData':
            var data =  new IpcDataModel.ChipArrayTwoSideFlatConcaveData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.chipArrayTwoSideFlatConcaveData, only3dModel);

            data.componentFamily(FootprintGeneratorDefaultParams.chipArrayTwoSideFlatConcaveData.componentFamily);
            data.customPadLength(FootprintGeneratorDefaultParams.chipArrayTwoSideFlatConcaveData.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.chipArrayTwoSideFlatConcaveData.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.chipArrayTwoSideFlatConcaveData.customPadToPadGap);
        break;

        case 'ChipArrayFourSideFlatConcaveData':
            var data =  new IpcDataModel.ChipArrayFourSideFlatConcaveData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.oddPadHeightMin);
            data.oddPadWidthMax(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.oddPadWidthMax);
            data.oddPadWidthMin(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.oddPadWidthMin);
            data.componentFamily(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.componentFamily);

            data.customPadLength(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.customPadLength);
            data.customOddPadLength(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.customOddPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.customPadWidth);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.customOddPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.customPadToPadGap);
            data.customPadToPadGap1(FootprintGeneratorDefaultParams.chipArrayFourSideFlatConcaveData.customPadToPadGap1);
        break;

        case 'ChipArrayTwoSideConvexData':
            var data =  new IpcDataModel.ChipArrayTwoSideConvexData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData, only3dModel);

            data.oddPadHeightMax(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.oddPadHeightMax);
            data.oddPadHeightMin(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.oddPadHeightMin);
            data.componentFamily(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.componentFamily);

            data.customPadLength(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.customPadLength);
            data.customOddPadWidth(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.customOddPadWidth);
            data.customPadWidth(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.chipArrayTwoSideConvexData.customPadToPadGap);
        break;

        case 'OscillatorCornerConcaveData':
            var data =  new IpcDataModel.OscillatorCornerConcaveData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.oscCornerConcave, only3dModel);

            data.horizontalTerminalGapMin(FootprintGeneratorDefaultParams.oscCornerConcave.horizontalTerminalGapMin);
            data.horizontalTerminalGapMax(FootprintGeneratorDefaultParams.oscCornerConcave.horizontalTerminalGapMax);
            data.verticalTerminalGapMin(FootprintGeneratorDefaultParams.oscCornerConcave.verticalTerminalGapMin);
            data.verticalTerminalGapMax(FootprintGeneratorDefaultParams.oscCornerConcave.verticalTerminalGapMax);
            data.customPadLength(FootprintGeneratorDefaultParams.oscCornerConcave.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.oscCornerConcave.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.oscCornerConcave.customPadToPadGap);
            data.customPadToPadGap1(FootprintGeneratorDefaultParams.oscCornerConcave.customPadToPadGap1);
        break;

        case 'OscillatorJLeadData':
            var data =  new IpcDataModel.OscillatorJLeadData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.oscJLead, only3dModel);

            data.terminalCenterToCenterDistance(FootprintGeneratorDefaultParams.oscJLead.terminalCenterToCenterDistance);

            data.customPadLength(FootprintGeneratorDefaultParams.oscJLead.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.oscJLead.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.oscJLead.customPadSpan1);
        break;

        case 'OscillatorLBendData':
            var data =  new IpcDataModel.OscillatorLBendData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.oscLBend, only3dModel);

            data.terminalCenterToCenterDistance(FootprintGeneratorDefaultParams.oscLBend.terminalCenterToCenterDistance);

            data.customPadLength(FootprintGeneratorDefaultParams.oscLBend.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.oscLBend.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.oscLBend.customPadSpan1);
        break;

        case 'SojData':
            var data =  new IpcDataModel.SojData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.soj, only3dModel);

            data.terminalCenterToCenterDistance(FootprintGeneratorDefaultParams.soj.terminalCenterToCenterDistance);
            data.customPadLength(FootprintGeneratorDefaultParams.soj.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.soj.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.soj.customPadSpan1);
        break;

        case 'BgaData':
            var data =  new IpcDataModel.BgaData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.bga, only3dModel);

            data.verticalPadCount(FootprintGeneratorDefaultParams.bga.verticalPadCount);
            data.horizontalPinPitch(FootprintGeneratorDefaultParams.bga.horizontalPinPitch);
            if(!only3dModel) data.terminalType(FootprintGeneratorDefaultParams.bga.terminalType);
            data.customPadDiameter(FootprintGeneratorDefaultParams.bga.customPadDiameter);

        break;

        case 'PlccData':
            var data =  new IpcDataModel.PlccData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.plcc, only3dModel);

            data.verticalPadCount(FootprintGeneratorDefaultParams.plcc.verticalPadCount);
            data.verticalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.plcc.verticalLeadToLeadSpanMax);
            data.verticalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.plcc.verticalLeadToLeadSpanMin);
            data.terminalCenterToCenterDistance(FootprintGeneratorDefaultParams.plcc.terminalCenterToCenterDistance);
            data.terminalCenterToCenterDistance2(FootprintGeneratorDefaultParams.plcc.terminalCenterToCenterDistance2);
            data.customPadLength(FootprintGeneratorDefaultParams.plcc.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.plcc.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.plcc.customPadSpan1);
            data.customPadSpan2(FootprintGeneratorDefaultParams.plcc.customPadSpan2);
        break;

        case 'QfpData':
            var data =  new IpcDataModel.QfpData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.qfp, only3dModel);

            data.verticalPadCount(FootprintGeneratorDefaultParams.qfp.verticalPadCount);
            data.verticalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.qfp.verticalLeadToLeadSpanMax);
            data.verticalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.qfp.verticalLeadToLeadSpanMin);
            data.customPadLength(FootprintGeneratorDefaultParams.qfp.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.qfp.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.qfp.customPadSpan1);
            data.customPadSpan2(FootprintGeneratorDefaultParams.qfp.customPadSpan2);
        break;

        /*case 'CqfpData':
            var data =  new IpcDataModel.CqfpData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.cqfp, only3dModel);
            data.verticalPadCount(FootprintGeneratorDefaultParams.cqfp.verticalPadCount);
            data.verticalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.cqfp.verticalLeadToLeadSpanMax);
            data.verticalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.cqfp.verticalLeadToLeadSpanMin);
        break;*/

        case 'QfnData':
            var data =  new IpcDataModel.QfnData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.qfn, only3dModel);

            data.verticalPadCount(FootprintGeneratorDefaultParams.qfn.verticalPadCount);
            data.verticalLeadToLeadSpanMax(FootprintGeneratorDefaultParams.qfn.verticalLeadToLeadSpanMax);
            data.verticalLeadToLeadSpanMin(FootprintGeneratorDefaultParams.qfn.verticalLeadToLeadSpanMin);
            data.customPadLength(FootprintGeneratorDefaultParams.qfn.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.qfn.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.qfn.customPadSpan1);
            data.customPadSpan2(FootprintGeneratorDefaultParams.qfn.customPadSpan2);

        break;

        case 'SonData':
            data = new IpcDataModel.SonData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.son, only3dModel);

            data.customPadLength(FootprintGeneratorDefaultParams.son.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.son.customPadWidth);
            data.customPadSpan1(FootprintGeneratorDefaultParams.son.customPadSpan1);
        break;

        case 'AxialData':
            var data =  new IpcDataModel.AxialData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.axial, only3dModel);
        break;

        case 'DipData':
            var data =  new IpcDataModel.DipData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.dip, only3dModel);
        break;

        case 'HeaderStraightData':
            var data =  new IpcDataModel.HeaderStraightData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.headerStraightData, only3dModel);
        break;

        case 'HeaderRightAngleData':
            var data =  new IpcDataModel.HeaderRightAngleData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.headerRightAngleData, only3dModel);
        break;

        case 'HeaderStraightSocketData':
            var data =  new IpcDataModel.HeaderStraightSocketData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.headerStraightSocketData, only3dModel);
        break;

        case 'HeaderRightAngleSocketData':
            var data =  new IpcDataModel.HeaderRightAngleSocketData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.headerRightAngleSocketData, only3dModel);
        break;

        case 'RadialRoundData':
            var data =  new IpcDataModel.RadialRoundData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.radialRoundData, only3dModel);
        break;

        case 'RadialLedRoundData':
            var data =  new IpcDataModel.RadialLedRoundData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.radialLedRoundData, only3dModel);
        break;

        case 'CrystalHC49Data':
            var data =  new IpcDataModel.CrystalHC49Data(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.crystalHC49Data, only3dModel);
        break;
        
        case 'FemaleStandoffSpacerData':
            var data =  new IpcDataModel.FemaleStandoffSpacerData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.femaleStandoffSpacerData, only3dModel);

            if (!only3dModel) {
                data.plated(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.plated);
                data.withPad(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.withPad);
                data.viaThermalRelief(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.viaThermalRelief);
                data.withVia(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.withVia);
                data.viaCount(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.viaCount);
                data.viaDiameter(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.viaDiameter);
                data.viaCenterOffset(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.viaCenterOffset);
                data.padDiameter(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.padDiameter);
                data.holeDiameter(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.holeDiameter);
            }

            data.hasThread(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.hasThread);
            data.threadDepth(FootprintGeneratorDefaultParams.femaleStandoffSpacerData.threadDepth);
        break;

        case 'MaleFemaleStandoffSpacerData':
            var data =  new IpcDataModel.MaleFemaleStandoffSpacerData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData, only3dModel);

            if (!only3dModel) {
                data.plated(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.plated);
                data.withPad(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.withPad);
                data.viaThermalRelief(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.viaThermalRelief);
                data.withVia(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.withVia);
                data.viaCount(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.viaCount);
                data.viaDiameter(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.viaDiameter);
                data.viaCenterOffset(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.viaCenterOffset);
                data.padDiameter(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.padDiameter);
                data.holeDiameter(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.holeDiameter);
            }

            data.postLength(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.postLength);
            data.innerThreadDepth(FootprintGeneratorDefaultParams.maleFemaleStandoffSpacerData.innerThreadDepth);
        break;

        case 'SnapLockData':
            var data =  new IpcDataModel.SnapLockData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.SnapLockData, only3dModel);
        
            data.holeDiameter(FootprintGeneratorDefaultParams.SnapLockData.holeDiameter);
            data.boardThickness(FootprintGeneratorDefaultParams.SnapLockData.boardThickness);
            data.lockHeightMin(FootprintGeneratorDefaultParams.SnapLockData.lockHeightMin);
            data.lockHeightMax(FootprintGeneratorDefaultParams.SnapLockData.lockHeightMax);
            data.lockWidth(FootprintGeneratorDefaultParams.SnapLockData.lockWidth);

        break;

        case 'ChipLedData':
            var data =  new IpcDataModel.ChipLedData(startCoord, 0, !only3dModel);
            this.applyParamsToData(data, FootprintGeneratorDefaultParams.ChipLedData, only3dModel);

            data.baseHeightMax(FootprintGeneratorDefaultParams.ChipLedData.baseHeightMax);
            data.baseHeightMin(FootprintGeneratorDefaultParams.ChipLedData.baseHeightMin);
            data.domeDiameter(FootprintGeneratorDefaultParams.ChipLedData.domeDiameter);

            data.customPadLength(FootprintGeneratorDefaultParams.ChipLedData.customPadLength);
            data.customPadWidth(FootprintGeneratorDefaultParams.ChipLedData.customPadWidth);
            data.customPadToPadGap(FootprintGeneratorDefaultParams.ChipLedData.customPadToPadGap);
        break;
    }

    if(!only3dModel) this.updatePadNames(data, rootData);
    return data;
};

// TODO: Refactor since this is getting longer
//note: params can have value 0 which is allowed
FootprintGeneratorAddHelper.applyParamsToData = function(data, params, only3dModel) {
    if(!data) return;
    if(typeof params !== 'object') return;

    if(params.horizontalPadCount !== undefined) {
        data.horizontalPadCount(params.horizontalPadCount);
    }

    if(params.horizontalLeadToLeadSpanMax !== undefined) {
        data.horizontalLeadToLeadSpanMax(params.horizontalLeadToLeadSpanMax);
    }

    if(params.horizontalLeadToLeadSpanMin !== undefined) {
        data.horizontalLeadToLeadSpanMin(params.horizontalLeadToLeadSpanMin);
    }

    if(params.padWidthMax !== undefined) {
        data.padWidthMax(params.padWidthMax);
    }

    if(params.padWidthMin !== undefined) {
        data.padWidthMin(params.padWidthMin);
    }

    if(params.padHeightMax !== undefined) {
        data.padHeightMax(params.padHeightMax);
    }

    if(params.padHeightMin !== undefined) {
        data.padHeightMin(params.padHeightMin);
    }

    if(params.thermalPadLength !== undefined) {
        data.thermalPadLength(params.thermalPadLength);
    }

    if(params.thermalPadWidth !== undefined) {
        data.thermalPadWidth(params.thermalPadWidth);
    }

    if(!only3dModel) {
        if(params.thermalPadSolderPasteStencilApertureGapX !== undefined) {
            data.thermalPadSolderPasteStencilApertureGapX(params.thermalPadSolderPasteStencilApertureGapX);
        }

        if(params.thermalPadSolderPasteStencilApertureGapY !== undefined) {
            data.thermalPadSolderPasteStencilApertureGapY(params.thermalPadSolderPasteStencilApertureGapY);
        }

        if(params.thermalPadSolderPasteStencilApertureLength !== undefined) {
            data.thermalPadSolderPasteStencilApertureLength(params.thermalPadSolderPasteStencilApertureLength);
        }

        if(params.thermalPadSolderPasteStencilApertureWidth !== undefined) {
            data.thermalPadSolderPasteStencilApertureWidth(params.thermalPadSolderPasteStencilApertureWidth);
        }

        if(params.thermalPadSolderPasteStencilRowCount !== undefined) {
            data.thermalPadSolderPasteStencilRowCount(params.thermalPadSolderPasteStencilRowCount);
        }

        if(params.thermalPadSolderPasteStencilColCount !== undefined) {
            data.thermalPadSolderPasteStencilColCount(params.thermalPadSolderPasteStencilColCount);
        }
    }

    if(params.verticalPinPitch !== undefined) {
        data.verticalPinPitch(params.verticalPinPitch);
    }

    if(params.bodyWidthMax !== undefined) {
        data.bodyWidthMax(params.bodyWidthMax);
    }

    if(params.bodyWidthMin !== undefined) {
        data.bodyWidthMin(params.bodyWidthMin);
    }

    if(params.bodyLengthMax !== undefined) {
        data.bodyLengthMax(params.bodyLengthMax);
    }

    if(params.bodyLengthMin !== undefined) {
        data.bodyLengthMin(params.bodyLengthMin);
    }

    if(params.bodyHeightMax !== undefined) {
        data.bodyHeightMax(params.bodyHeightMax);
    }

    if(params.bodyHeightMin !== undefined) {
        data.bodyHeightMin(params.bodyHeightMin);
    }

    if(params.bodyOffsetMax !== undefined) {
        data.bodyOffsetMax(params.bodyOffsetMax);
    }

    if(params.bodyOffsetMin !== undefined) {
        data.bodyOffsetMin(params.bodyOffsetMin);
    }

    if(data instanceof IpcDataModel.IpcPthPadGeneratorData) {
        if(params.terminalWidth !== undefined) {
            data.terminalWidth(params.terminalWidth);
        }

        if(params.terminalLength !== undefined) {
            data.terminalLength(params.terminalLength);
        }

        if(params.terminalThickness !== undefined) {
            data.terminalThickness(params.terminalThickness);
        }

        if(params.leadSpan !== undefined) {
            data.leadSpan(params.leadSpan);
        }

        if(params.bodyOffset !== undefined) {
            data.bodyOffset(params.bodyOffset);
        }

        if(params.verticalPadCount !== undefined) {
            data.verticalPadCount(params.verticalPadCount);
        }

        if(params.terminalTailLength !== undefined) {
            data.terminalTailLength(params.terminalTailLength);
        }

        if(params.horizontalTerminalTailLength !== undefined) {
            data.horizontalTerminalTailLength(params.horizontalTerminalTailLength);
        }

        if(params.verticalTerminalTailLength !== undefined) {
            data.verticalTerminalTailLength(params.verticalTerminalTailLength);
        }

        if(params.terminalPostLength !== undefined) {
            data.terminalPostLength(params.terminalPostLength);
        }

        if(params.pinNumberSequencePattern !== undefined) {
            data.pinNumberSequencePattern(params.pinNumberSequencePattern);
        }

        if(params.horizontalPinPitch !== undefined) {
            data.horizontalPinPitch(params.horizontalPinPitch);
        }

        if(!only3dModel && params.padToHoleRatio !== undefined) {
            data.padToHoleRatio(params.padToHoleRatio);
        }
    }
};

module.exports = FootprintGeneratorAddHelper;
